import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function About() {
  const { t } = useTranslation();

  const orgSchema = {
    name: '黑料吃瓜在线',
    url: 'http://hngzxny.cn/',
    description: '最新娱乐资讯聚合平台，聚焦明星八卦、网红动态、综艺热点与影视资讯。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@hngzxny.cn',
    },
  };

  const faqSchema = {
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料吃瓜在线是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料吃瓜在线是一个专业的娱乐资讯聚合平台，每日更新明星八卦、网红动态、综艺热点和影视资讯，为用户提供最新最全的娱乐头条。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜在线更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的编辑团队全天候跟踪娱乐热点，每日更新多条原创资讯内容，确保您不会错过任何精彩爆料。',
        },
      },
      {
        '@type': 'Question',
        name: '如何订阅黑料吃瓜在线的推送？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以在网站底部的订阅区域输入您的邮箱地址，订阅后即可第一时间收到最新娱乐资讯推送。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜在线内容是否可信？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来源于权威娱乐媒体和官方渠道，每篇报道均标注信息来源，确保内容的真实性和可靠性。',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://hngzxny.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  return (
    <>
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <SchemaOrg type="BreadcrumbList" data={breadcrumbSchema} />

      <main>
        <Navbar />

        <section className="relative w-full min-h-[500px] md:min-h-[650px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20modern%20creative%20workspace%20with%20multiple%20monitors%20displaying%20entertainment%20news%20content%2C%20journalists%20and%20editors%20collaborating%20in%20an%20open%20office%20layout%2C%20warm%20ambient%20lighting%20with%20industrial%20design%20elements%2C%20professional%20media%20company%20environment%2C%20exposed%20brick%20walls%20and%20modern%20furniture%2C%20creative%20and%20dynamic%20atmosphere%2C%20cinematic%20wide%20angle&width=1800&height=900&seq=about-hero-2026-x1&orientation=landscape"
            alt="黑料吃瓜在线团队"
            title="黑料吃瓜在线 - 关于我们"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-secondary-900/60 via-secondary-900/35 to-secondary-900/70"></div>

          <div className="relative z-10 w-full px-4 md:px-6 py-32 md:py-40">
            <div className="max-w-[1280px] mx-auto">
              <div className="max-w-2xl">
                <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-accent-500/90 text-background-50 mb-6 whitespace-nowrap">
                  品牌介绍
                </span>
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
                  关于
                  <span className="text-accent-400">黑料吃瓜在线</span>
                </h1>
                <p className="mt-6 text-base md:text-lg text-background-50/75 leading-relaxed max-w-xl">
                  黑料吃瓜在线成立于2024年，是一支热爱娱乐资讯的专业团队。我们致力于为用户提供最新、最全、最有趣的娱乐八卦和明星动态，让每一位"吃瓜群众"都能第一时间掌握圈内热点。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-secondary-900 px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <span className="inline-block px-3 py-1 rounded text-xs font-medium bg-accent-100/20 text-accent-400 whitespace-nowrap">
                  ABOUT / 关于
                </span>
                <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50">
                  做最懂你的娱乐资讯平台
                </h2>
                <div className="mt-6 space-y-4 text-sm text-background-50/65 leading-relaxed">
                  <p>
                    在这个信息爆炸的时代，娱乐资讯层出不穷、真假难辨。黑料吃瓜在线成立的初衷，就是为广大的"吃瓜群众"提供一个真实、及时、全面的娱乐资讯聚合平台。
                  </p>
                  <p>
                    我们的编辑团队由资深娱乐记者和内容创作者组成，全天候追踪娱乐圈最新动态。从明星八卦到网红翻车，从综艺热点到影视资讯，我们力争在第一时间为你送上最劲爆的内容。
                  </p>
                  <p>
                    每一篇报道我们都标注了信息来源，确保内容的可信度。我们相信，好的娱乐资讯不仅要快、要全，更要真实可靠。
                  </p>
                </div>

                <div className="mt-8 grid grid-cols-3 gap-4">
                  <div className="text-center p-4 rounded-lg bg-secondary-800/50">
                    <div className="font-heading text-3xl md:text-4xl font-bold text-accent-500">50+</div>
                    <div className="mt-1 text-xs text-foreground-400">每日更新资讯</div>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-secondary-800/50">
                    <div className="font-heading text-3xl md:text-4xl font-bold text-accent-500">200万+</div>
                    <div className="mt-1 text-xs text-foreground-400">月活跃读者</div>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-secondary-800/50">
                    <div className="font-heading text-3xl md:text-4xl font-bold text-accent-500">4</div>
                    <div className="mt-1 text-xs text-foreground-400">核心内容分类</div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20diverse%20team%20of%20young%20creative%20professionals%20collaborating%20in%20a%20modern%20media%20office%2C%20discussing%20content%20on%20laptops%20and%20screens%2C%20warm%20and%20inviting%20workspace%20with%20plants%20and%20natural%20light%2C%20casual%20yet%20professional%20atmosphere%2C%20editorial%20team%20meeting%2C%20vibrant%20and%20energetic%20mood%2C%20clean%20modern%20aesthetic&width=700&height=700&seq=about-team-2026-x2&orientation=squarish"
                  alt="黑料吃瓜在线编辑团队"
                  title="黑料吃瓜在线 - 编辑团队"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50 px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div className="order-2 lg:order-1">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20confident%20Chinese%20media%20professional%20in%20a%20modern%20office%20setting%2C%20wearing%20smart%20casual%20attire%2C%20looking%20thoughtfully%20at%20camera%2C%20black%20and%20white%20portrait%20photography%20style%2C%20side%20profile%20angle%2C%20clean%20white%20background%2C%20professional%20headshot%20with%20character&width=600&height=800&seq=about-founder-2026-x3&orientation=portrait"
                  alt="创始人 - 李明"
                  title="黑料吃瓜在线创始人 李明"
                  className="w-full rounded-lg"
                />
              </div>

              <div className="order-1 lg:order-2">
                <span className="flex items-center gap-2 text-sm font-medium text-foreground-600">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                  创始人寄语
                </span>
                <blockquote className="mt-4 font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight">
                  &ldquo;让每一位吃瓜群众
                  <br />
                  都能第一时间
                  <br />
                  掌握圈内热点&rdquo;
                </blockquote>
                <div className="mt-6 flex items-center gap-3">
                  <div>
                    <p className="font-semibold text-foreground-900">李明</p>
                    <p className="text-sm text-foreground-500">黑料吃瓜在线 创始人兼总编辑</p>
                  </div>
                  <span className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-verified-badge-fill text-base"></i>
                    官方认证
                  </span>
                </div>
                <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
                  作为一位在娱乐媒体行业深耕十年的老兵，我深知用户对于高质量娱乐资讯的渴求。黑料吃瓜在线汇聚了业内最优秀的内容团队，我们将继续秉持"真实、及时、有趣"的理念，为广大读者提供最优质的娱乐资讯服务。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="relative w-full py-20 md:py-28 px-4 md:px-6 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20modern%20media%20headquarters%20building%20exterior%20at%20golden%20hour%2C%20glass%20facade%20reflecting%20warm%20sunset%20light%2C%20urban%20cityscape%20background%2C%20professional%20corporate%20photography%2C%20clean%20architectural%20lines%2C%20warm%20and%20inviting%20atmosphere%2C%20high-end%20commercial%20building&width=1800&height=600&seq=about-cta-2026-x4&orientation=landscape"
            alt="联系我们"
            title="黑料吃瓜在线 - 联系我们"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/85 via-secondary-900/55 to-secondary-900/35"></div>

          <div className="relative z-10 max-w-[1280px] mx-auto">
            <div className="max-w-lg">
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                联系我们
              </h2>
              <p className="mt-4 text-base text-background-50/70 leading-relaxed">
                如果您有任何新闻线索、合作意向或意见建议，欢迎随时与我们取得联系。我们期待听到您的声音。
              </p>
              <div className="mt-8 space-y-4">
                <div className="flex items-center gap-3 text-background-50/80">
                  <span className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </span>
                  <span className="text-sm">hello@hngzxny.cn</span>
                </div>
                <div className="flex items-center gap-3 text-background-50/80">
                  <span className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-lg"></i>
                  </span>
                  <span className="text-sm">400-888-9999</span>
                </div>
                <div className="flex items-center gap-3 text-background-50/80">
                  <span className="w-10 h-10 rounded-full bg-background-50/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-lg"></i>
                  </span>
                  <span className="text-sm">北京市朝阳区建国路88号SOHO现代城A座</span>
                </div>
              </div>

              <a
                href="mailto:hello@hngzxny.cn"
                className="mt-8 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-secondary-900 font-semibold text-sm hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                立即联系
                <span className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm text-background-50"></i>
                </span>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}